module.exports = __webpack_public_path__ + "img/img_shows_pc_5.ff3332f6.png";